import { Configuration, ApiConfigOptions } from '@sg/api/base-api-lib';

export interface ClientIntegrationApiConfigOptions extends ApiConfigOptions {}
export class ClientIntegrationApiConfig extends Configuration {
  constructor(configOptions?: ClientIntegrationApiConfigOptions) {
    super({ ...{}, ...(configOptions || {}) });
  }
}
